import { render, staticRenderFns } from "./EstadoCarterasActualizadas.vue?vue&type=template&id=20c94cc8&"
import script from "./EstadoCarterasActualizadas.vue?vue&type=script&lang=js&"
export * from "./EstadoCarterasActualizadas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports